import Greenbay1 from '../../Media/Greenbay/Kamar 1 (1).webp'
import Greenbay2 from '../../Media/Greenbay/Kamar 1 (2).webp'
import Greenbay3 from '../../Media/Greenbay/Kamar 1 (3).webp'
import Greenbay4 from '../../Media/Greenbay/Kamar 1 (4).webp'




const Kamar1images =[
    Greenbay1,Greenbay2,Greenbay3,Greenbay4
]

export default Kamar1images;